import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { IGetDataPayload, ISetPromocodePayload, IGetDataResponse } from './../model/types'

export const discountGetData = async (payload: IGetDataPayload) => {
  const res: AxiosResponse<IGetDataResponse> = await api.post('external-api/novikov-set-discount', payload)
  return res
}

export const discountSetPromoCode = async (payload: ISetPromocodePayload) => {
  const res: AxiosResponse = await api.post('order/promo-code', payload)
  return res
}
